import { Routes } from '@angular/router';

import { authGuard, loggedInGuard } from '@auth/guards/auth.guard';
import { onboardingGuard, producerOnboardedGuard } from '@core/guards/producer-status.guard';
import { DASHBOARD_PATHS } from '@dashboard/dashboard.routes';
import { LANDING_PATHS } from '@landing/landing.routes';
import { MY_MENU_PATHS } from '@my-menu/my-menu.routes';
import { ONBOARDING_PATHS } from '@onboarding/onboarding.routes';
import { ORDERS_PATHS } from '@orders/orders.routes';
import { PRODUCER_PROFILE_PATHS } from '@producer-profile/producer-profile.routes';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: DASHBOARD_PATHS.BASE,
    pathMatch: 'full'
  },
  {
    // MSAL's configured redirectUri (environment.entraAuth.redirectUrl): where a sign-in redirect returns to, and
    // where a silent token renewal's hidden iframe lands. The app initializer consumes the redirect's hash before the
    // router's initial navigation reaches here, so by the time either does there's nothing left to do but move on.
    path: 'login',
    redirectTo: DASHBOARD_PATHS.BASE,
    pathMatch: 'full'
  },
  {
    path: LANDING_PATHS.BASE,
    loadChildren: async () => import('./modules/landing/landing.routes').then((m) => m.LandingRoutes),
    canActivate: [loggedInGuard],
    data: {
      headerColor: 'light',
      hideBreadcrumbs: true
    }
  },
  {
    path: ONBOARDING_PATHS.BASE,
    loadChildren: () => import('./modules/onboarding/onboarding.routes').then((m) => m.OnboardingRoutes),
    canActivate: [authGuard, onboardingGuard],
    data: {
      hideHeader: true,
      hideBreadcrumbs: true
    }
  },
  {
    path: DASHBOARD_PATHS.BASE,
    loadChildren: () => import('./modules/dashboard/dashboard.routes').then((m) => m.DashboardRoutes),
    data: {
      title: 'Dashboard.Dashboard'
    },
    canActivate: [authGuard, producerOnboardedGuard]
  },
  {
    path: PRODUCER_PROFILE_PATHS.BASE,
    loadChildren: () =>
      import('./modules/producer-profile/producer-profile.routes').then((m) => m.ProducerProfileRoutes),
    data: {
      title: 'Producer_Profile.Title'
    },
    canActivate: [authGuard, producerOnboardedGuard]
  },
  {
    path: MY_MENU_PATHS.BASE,
    loadChildren: () => import('./modules/my-menu/my-menu.routes').then((m) => m.MyMenuRoutes),
    data: {
      title: 'My_Menu.Title'
    },
    canActivate: [authGuard, producerOnboardedGuard]
  },
  {
    path: ORDERS_PATHS.BASE,
    loadChildren: () => import('./modules/orders/orders.routes').then((m) => m.OrdersRoutes),
    data: {
      title: 'Orders.Orders'
    },
    canActivate: [authGuard, producerOnboardedGuard]
  },
  {
    path: 'not-found',
    loadComponent: () => import('@core/components/page-not-found/page-not-found').then((m) => m.PageNotFound)
  }
];
